module.exports = __webpack_public_path__ + "static/media/financepic5.bf29fd39.png";